import { render } from "./playlistHistory.vue?vue&type=template&id=be274de2&scoped=true"
import script from "./playlistHistory.vue?vue&type=script&lang=js"
export * from "./playlistHistory.vue?vue&type=script&lang=js"

import "./playlistHistory.vue?vue&type=style&index=0&id=be274de2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be274de2"

export default script